import { Injectable } from '@angular/core';
import { IndicadoresRepository } from '@app/data/indicadores/indicadores.repository';
import { IndicadoresResponse } from '@app/data/indicadores/models/indicadores.model';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardController {
  constructor(private indicadoresRepository: IndicadoresRepository) {}

  getIndicadores(indicadores: string[], dataInicial?: string, dataFinal?: string): Observable<IndicadoresResponse> {
    return this.indicadoresRepository.getIndicadores(indicadores, dataInicial, dataFinal);
  }
}
